import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdAdd, MdApproval, MdArrowBack, MdArrowRightAlt, MdAttachFile, MdClass, MdDone, MdEmail, MdInbox, MdLock, MdMail, MdMarkunreadMailbox, MdOutlineApproval, MdOutlineSettingsSuggest, MdPassword, MdPersonPinCircle, MdRememberMe, MdResetTv, MdSchool, MdSend, MdSettings, MdSettingsAccessibility } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function ManageStudents() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} overflow-x-hidden w-screen xl:pt-[20px] `}>
            <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full">
                <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                    <MdArrowBack size={25} className="md:hidden" onClick={() => {
                        navigate('/mobile/teacher/dashboard')
                    }} />
                    <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                        navigate('/mobile/teacher/dashboard')
                    }} />
                    <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                        navigate('/desktop/teacher/dashboard')
                    }} />
                    <p className={`${i18n.language === "ta" ?"text-[15px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px]":"text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px]"}font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]`}>{t('t110')}</p>
                </div>
            </div>
            <div className={`xl:hidden flex flex-col mt-[20px] md:mt-[40px] ml-[30px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px] ${i18n.language === "en" ? "h-[50px]" : "h-[70px]"}`} onClick={() => navigate('/teacher/invitestudents')}>
                <div className="flex items-center h-full">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full flex items-center">
                        <MdAdd size={25} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full flex items-center">
                        <MdAdd size={28} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[9px] md:py-[16px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t111')}</p>
                    </div>
                </div>
            </div>
            <div className={`xl:hidden flex flex-col mt-[20px] md:mt-[40px] ml-[30px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px] ${i18n.language === "en" ? "h-[50px]" : "h-[70px]"}`} onClick={() => navigate('/teacher/request/select')}>
                <div className="flex items-center h-full">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full flex items-center">
                        <MdDone size={25} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full flex items-center">
                        <MdDone size={28} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[9px] md:py-[16px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t112')}</p>
                    </div>
                </div>
            </div>

            <div className={`xl:hidden flex flex-col mt-[20px] md:mt-[40px] ml-[30px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px] ${i18n.language === "en" ? "h-[50px]" : "h-[70px]"}`} onClick={() => navigate('/teacher/resetpassword')}>
                <div className="flex items-center h-full">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full flex items-center">
                        <MdPassword size={25} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full flex items-center">
                        <MdPassword size={28} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[9px] md:py-[16px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t113_1')}</p>
                    </div>
                </div>
            </div>

            <div className={`xl:hidden flex flex-col mt-[20px] md:mt-[40px] ml-[30px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px] ${i18n.language === "en" ? "h-[50px]" : "h-[70px]"}`} onClick={() => navigate('/teacher/sendrequest/status')}>
                <div className="flex items-center h-full">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full flex items-center">
                        <MdSend size={25} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full flex items-center">
                        <MdSend size={28} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[9px] md:py-[16px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t261')}</p>
                    </div>
                </div>
            </div>
            <div className={`xl:hidden flex flex-col mt-[20px] md:mt-[40px] ml-[30px] mr-[20px] md:ml-[150px] md:mr-[150px] lg:ml-[200px] lg:mr-[200px] ${i18n.language === "en" ? "h-[50px]" : "h-[70px]"}`} onClick={() => navigate('/teacher/resetpassword/student/check')}>
                <div className="flex items-center h-full">
                    <div className="md:hidden bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full flex items-center">
                        <MdLock size={25} color="#FDC50C" />
                    </div>
                    <div className="hidden md:block bg-[#A07B00] p-[8px] md:p-[15px] rounded-l-lg h-full flex items-center">
                        <MdLock size={28} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[9px] md:py-[16px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[15px] md:text-[18px]">{t('t113')}</p>
                    </div>
                </div>
            </div>
            <div className="xl:hidden pb-[20px] md:pb-[130px]">

            </div>

            <div className="hidden xl:grid grid-cols-4 mt-[30px] 2xl:mt-[50px] ml-[80px] mr-[70px] 2xl:ml-[100px] 2xl:mr-[100px]">
                <div className="flex justify-center items-center mr-[20px] cursor-pointer xl:h-[70px]" onClick={() => navigate('/teacher/invitestudents')}>
                    <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                        <MdAdd size={30} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[16px] font-bold">{t('t111')}</p>
                    </div>
                </div>
                <div className="flex justify-center items-center mr-[20px] cursor-pointer xl:h-[70px]" onClick={() => navigate('/teacher/request/select')}>
                    <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                        <MdDone size={30} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[16px] font-bold">{t('t112')}</p>
                    </div>
                </div>
                <div className="flex justify-center items-center mr-[20px] cursor-pointer xl:h-[70px]" onClick={() => navigate('/teacher/resetpassword')}>
                    <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                        <MdPassword size={30} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[16px] font-bold">{t('t113_1')}</p>
                    </div>
                </div>
                <div className="flex justify-center items-center mr-[20px] cursor-pointer xl:h-[70px]" onClick={() => navigate('/teacher/sendrequest/status')}>
                    <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                        <MdSend size={30} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[16px] font-bold">{t('t270')}</p>
                    </div>
                </div>
                <div className="flex justify-center items-center mr-[20px] cursor-pointer xl:h-[70px] mt-[20px]" onClick={() => navigate('/teacher/resetpassword/student/check')}>
                    <div className="p-[17px] bg-[#A07B00] rounded-l-lg h-full flex items-center">
                        <MdLock size={30} color="#FDC50C" />
                    </div>
                    <div className="bg-[#FFEBA9] py-[20px] pl-[10px] w-full rounded-r-lg h-full flex items-center">
                        <p className="text-black text-[16px] font-bold">{t('t113')}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageStudents;